import { combineReducers } from 'redux';

import errors from './errors';
import global from './global';
import * as auth from './auth';
import * as prod from './prod';
import * as order from './order';
import * as home from './home';
import * as user from './user';
import * as visa from './visa';
import * as subject from './subject';
import * as destination from './destination';
import * as search from './search';
import * as coupon from './coupon';
import * as exam from './exam';
import * as pet from './pet';

const rootReducer = combineReducers({
  errors,
  global,
  ...auth,
  ...prod,
  ...order,
  ...home,
  ...user,
  ...visa,
  ...subject,
  ...destination,
  ...search,
  ...coupon,
  ...exam,
  ...pet,
});

export default rootReducer;
